module.exports = __webpack_public_path__ + "static/media/included2.97211049.svg";